/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { LeadCommentCount } from './LeadCommentCount';
import {
    LeadCommentCountFromJSON,
    LeadCommentCountFromJSONTyped,
    LeadCommentCountToJSON,
} from './LeadCommentCount';

/**
 * 
 * @export
 * @interface FindLeadsBatchWithCommentCounts200Response
 */
export interface FindLeadsBatchWithCommentCounts200Response {
    /**
     * 
     * @type {Array<LeadCommentCount>}
     * @memberof FindLeadsBatchWithCommentCounts200Response
     */
    data?: Array<LeadCommentCount>;
}

/**
 * Check if a given object implements the FindLeadsBatchWithCommentCounts200Response interface.
 */
export function instanceOfFindLeadsBatchWithCommentCounts200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FindLeadsBatchWithCommentCounts200ResponseFromJSON(json: any): FindLeadsBatchWithCommentCounts200Response {
    return FindLeadsBatchWithCommentCounts200ResponseFromJSONTyped(json, false);
}

export function FindLeadsBatchWithCommentCounts200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindLeadsBatchWithCommentCounts200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(LeadCommentCountFromJSON)),
    };
}

export function FindLeadsBatchWithCommentCounts200ResponseToJSON(value?: FindLeadsBatchWithCommentCounts200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(LeadCommentCountToJSON)),
    };
}

